export default __webpack_public_path__ + "static/dark_logo-45b7c26041524273b6eb86814c502fc8.png";